module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/logo2.4c6fa1ec.png";